function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,228.74a4,4,0,0,0,5.66,0l33.91-33.91a4,4,0,0,0,0-5.66l-33.91-33.9a4,4,0,0,0-5.66,5.65L185.85,188H98.91c2-47,39.33-85.7,86.62-88.94a4,4,0,1,0-.55-8C132.18,94.7,90.81,139,90.81,192S132.18,289.3,185,292.93h.28a4,4,0,0,0,.27-8C138.24,281.7,100.92,243,98.91,196h86.94l-27.08,27.08A4,4,0,0,0,158.77,228.74Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,292.93a4,4,0,0,1-.27-8,93.16,93.16,0,0,0,0-185.88,4,4,0,1,1,.55-8c52.8,3.62,94.17,48,94.17,100.92S251.82,289.3,199,292.93Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,262.05a4,4,0,0,1-.4-8,62.39,62.39,0,0,0,0-124.14,4,4,0,0,1,.8-8,70.39,70.39,0,0,1,0,140.06A2.68,2.68,0,0,1,198.74,262.05Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,231.92A4,4,0,0,1,198,224a32.54,32.54,0,0,0,0-64,4,4,0,0,1,1.47-7.87,40.54,40.54,0,0,1,0,79.7A3.78,3.78,0,0,1,198.74,231.92Z",
    style: {
      fill: "#f8b417"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherApplications);
export default __webpack_public_path__ + "static/media/other-applications.1436070170ec54e92d60c8a10b47657d.svg";
export { ForwardRef as ReactComponent };